/*Vendor Management*/
import axios from 'axios'

import { ApiService } from "./api.service";
import { downloadFile } from "../_helpers/downloadFile"
import { ToastService } from './toast.service';

export const PMService = {
    fetchVendor,
    fetchVendorList,
    vendorCreate,
    vendorUpdate,
    vendorDelete,
    vendorRemoveTemp,
    updateRateExchangeOpenMasterTrans,
    updateCurrencyOpenMasterTrans,
    receiptPO,
    processPurchaseOrder,
    bookNewReceiptTransaction,
    deleteBookReceiptTransaction,
    createRCTItem,
    updateRCTItem,
    updateInformationProduct,
    deleteRCTItem,
    fetchRCTItems,
    fetchROD_information,
    fetchOrCreateRCT,
    fetchReceiptTaxSummary,
    saveOpenMasterTrans,
    saveVendorOpenMasterTrans,
    fetchROMList,
    fetchProductReceive,
    transactionOpenLotItemGetList,
    transactionOpenLotItemPost,
    transactionOpenLotItemDelete,
    postReceiptTransaction,
    fetchPOTaxSummary,
    fetchPO,
    fetchOrCreatePO,
    fetchPOs,
    updatePO,
    updatePOVendor,
    updatePOCurrency,
    deletePO,
    fetchPOItems,
    fetchPOItemsByOrderNumber,
    createPOItem,
    updatePOItem,
    deletePOItem,
    releasePO,
    downloadVendorExcel,
    downloadReceiptsHistoryExcel,
    downloadPurchaseOrdersHistoryExcel
}

/* Vendor */
function fetchVendor(vendor_code) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post(`/pm/vendor/r/`,{vendor_code});
}

function fetchVendorList(query, page) {
    /**
    //    * Fetch all vendor with limit 25
    //    *
    //    * @returns array
    //    **/
    return ApiService.get(`/pm/vendor-list?query=${query}&page=${page}`);
}

function vendorCreate() {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post('/pm/vendor/c')
}

function vendorUpdate(id, data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put(`/pm/vendor/${id}`,data)
}

function vendorDelete(vendor_code)  {
    //   /**
    //    * @returns object deleted
    //    **/
    return ApiService.delete(`/pm/vendor/${vendor_code}`)
}

function vendorRemoveTemp (vendor_code) {
    //   /**
    //    * @returns object removed
    //    **/
    return ApiService.delete(`/pm/vendor/tmp/${vendor_code}`)
}

function processPurchaseOrder (data) {
    //   /**
    //    * @returns object removed
    //    **/
    return ApiService.post('/pm/sop/process-document',data)
}

/** Reception transaction */
function bookNewReceiptTransaction() {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post('/pm/receipt/book-transaction')
}

function deleteBookReceiptTransaction (id) {
    //   /**
    //    * @returns object
    //    **/

    return ApiService.delete(`/pm/receipt/book-transaction/${id}`)
}

function fetchProductReceive(productCode, vendorCode) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post(`/pm/receipt/item/${productCode}/${vendorCode}`)
}

function createRCTItem (data) {
    //   /**
    //    * @returns object
    //    **/

    return ApiService.post('/pm/receipt/item/', data)
}

function deleteRCTItem (id) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.delete(`/pm/receipt/item/${id}`,)
}

function updateRCTItem (data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put(`/pm/receipt/item/`,data)
}

function updateInformationProduct (data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put(`/pm/receipt/item/acceptance-requirements`,data)
}

function fetchROD_information(id) {
    //   /**
    //    * @returns array
    //    **/
    return ApiService.get(`/pm/receipt/item/acceptance-requirements/${id}`)
}

function fetchRCTItems(receiptNumber) {
    //   /**
    //    * @returns array
    //    **/
    return ApiService.get(`/pm/receipt/items?receiptNumber=${receiptNumber}`)
}

function fetchOrCreateRCT(receiptNumber) {
    //   /**
    //    * @returns array
    //    **/
    return ApiService.post(`/pm/receipt/`, { receiptNumber })
}

function fetchReceiptTaxSummary(receiptNumber) {
    return ApiService.get(`/pm/receipt/tax-summary/${receiptNumber}`)
}

function saveOpenMasterTrans(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/pm/receipt/transaction',data)
}

function saveVendorOpenMasterTrans(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/pm/receipt/vendor',data)
}

function updateRateExchangeOpenMasterTrans(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/pm/receipt/rate-exchange',data)
}

function updateCurrencyOpenMasterTrans(data) {
    return ApiService.put('/pm/receipt/currency',data)
}

function receiptPO(data) {
    return ApiService.post('/pm/receipt/purchase-order',data)
}

function fetchROMList(page){
    //   /**
   //    * @returns array
   //    **/
   return ApiService.get(`/pm/receipt/m/list/open-transaction?page=${page}`)
}

function transactionOpenLotItemGetList(receiptType, receiptNumber, lineNumber) {
    return ApiService.get(`pm/receipt/transaction/open/item/lot?receiptType=${receiptType}&receiptNumber=${receiptNumber}&lineNumber=${lineNumber}`)
}

function transactionOpenLotItemPost(data) {
    return ApiService.post(`pm/receipt/transaction/open/item/lot`, data)
}

function transactionOpenLotItemDelete(id) {
    return ApiService.delete(`pm/receipt/transaction/open/item/lot/${id}`)
}

function postReceiptTransaction (id) {

    //   /**
   //    * @returns object
   //    **/
   return ApiService.post('/pm/receipt/post-transaction', { id })
}

// function fetchOrCreatePO(orderNumber) {
//     return ApiService.post('/pm/purchase-order/', { orderNumber })
// }
function fetchPOTaxSummary (id) {
    return ApiService.get(`/pm/purchase-order/${id}/tax-summary`)
}

function fetchPO (orderNumber) {
    return ApiService.post(`/pm/purchase-order/`, {orderNumber})
}

function fetchOrCreatePO (orderNumber) {
    return ApiService.post('/pm/purchase-order/create', { orderNumber })
}

function fetchPOs (vendorCode, page, limit) {
    return ApiService.get(`/pm/purchase-orders?vendorCode=${vendorCode}&page=${page}&limit=${limit}`)
}

function updatePO (data) {
    return ApiService.put(`/pm/purchase-order`, data)
}

function updatePOVendor (data) {
    return ApiService.put(`/pm/purchase-order/vendor`, data)
}

function updatePOCurrency (data) {
    return ApiService.put(`/pm/purchase-order/currency`, data)
}

function deletePO (id) {
    return ApiService.delete(`/pm/purchase-order/${id}`)
}

function fetchPOItems (id, page, limit, productCode = "") {
    return ApiService.get(`/pm/purchase-order/items/${id}?page=${page}&limit=${limit}&productCode=${productCode}`)
}

function fetchPOItemsByOrderNumber (orderNumber, page, limit) {
    return ApiService.post(`/pm/purchase-order/items?page=${page}&limit=${limit}`, { orderNumber })
}

function createPOItem (data) {
    return ApiService.post(`/pm/purchase-order/item/`, data)
}

function updatePOItem (data) {
    return ApiService.put(`/pm/purchase-order/item/`, data)
}

function deletePOItem (id) {
    return ApiService.delete(`/pm/purchase-order/item/${id}`)
}

function releasePO (id) {
    return ApiService.put(`/pm/purchase-order/${id}/print`)
}

function downloadVendorExcel() {
    return axios({
        url:'/pm/reports/vendors/downloadExcel',
        method: 'GET',
        responseType: 'blob'
    })
    .then(response => downloadFile(response, `Proveedores.xlsx`))
}

function downloadReceiptsHistoryExcel(date1, date2, vendorCode, locationCode) {
    return axios({
        url:`/pm/reports/receipt-history/downloadExcel?date1=${date1}&date2=${date2}&vendorCode=${vendorCode}&locationCode=${locationCode}`,
        method: 'GET',
        responseType: 'blob'
    })
    .then(response => downloadFile(response, `Histórico de entradas de recepción.xlsx`))
}

function downloadPurchaseOrdersHistoryExcel(date1, date2, vendorCode, locationCode) {
  return axios({
      url:`/pm/reports/purchase-orders-history/downloadExcel?date1=${date1}&date2=${date2}&vendorCode=${vendorCode}&locationCode=${locationCode}`,
      method: 'GET',
      responseType: 'blob'
  })
  .then(response => downloadFile(response, `Histórico de ordenes de compra.xlsx`))
}




// WEBPACK FOOTER //
// ./src/services/pm.service.js